//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import cfr from './cfrList'
    export default{
        name:'christmas_form_two',
        components: {
            cfr
        },
        data(){
            return{
                child_birth:'',
                showPopupPicker:false,
                options1:['加强脐带部护理','加强母乳喂养'],
                list_id:'',
                showCfrList:false,
                cfrText:'',
                form:{
                    room:'',
                    baby_id:'',
                    live_time:'',
                    agent_id:'',
                    birth_day:'',
                    jaundice:'',
                    head_face:'正常',
                    heart_rate:'',
                    breathing:'',
                    limbs:'正常',
                    abdomen:'平软',
                    hip:'正常',
                    genitals:'正常',
                    special_case:'',
                    // deal_desc:'',
                    deal:'',
                    advisory_date:'',
                    shifts:'',
                    agent_sign:''
                },
                showSignature:false,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
                baby_list:[],
                get_host:host.host
            }
        },
        created(){
            this.get_baby_list()
            this.apiMemberInfo()
            if(this.$route.query.list_id){
                this.apiGetCfrList()
            }
        },
        methods:{
            GetNumberOfDays(date1,date2){//获得天数
                //date1：开始日期，date2结束日期
                var a1 = Date.parse(new Date(date1));
                var a2 = Date.parse(new Date(date2));
                var day = parseInt((a2-a1)/ (1000 * 60 * 60 * 24));//核心：时间戳相减，然后除以天数
                return day
            },
            change_advisory_date(value){
                let day = this.GetNumberOfDays(this.child_birth,value)+1
                this.form.birth_day = day
            },
             //获取宫底位置input值
            onChange(val){
                this.form.deal=val
                this.$refs.deal.focus()
                this.showPopupPicker=false
            },
            //获取查房人列表
            apiGetCfrList(){
                let params = {
                    token: this.$cookie.get('token'),
                    store_id:this.$cookie.get('store_id'),
                }
                Api.checkRoomApi.getCheckInfo(params).then ( res => {
                    console.info("获取查房人列表",res)
                    if(res.errcode == 1){
                        this.nurser_name = res.data.nurser_name//过滤了离院，
                        this.apiDetail(res.data.nurser_name)
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        }) 
                    }
                })
            },
            //点击选择查房人
            selectPeople(){
                this.showCfrList = true
            },
            //赋值查房人ID
            cfrListEven(val,item){
                this.showCfrList = val
                if(item){
                    this.form.agent_id = item.id
                    this.cfrText = item.user_name
                }
            },
            //选择宝宝
            checkerChange(value){
                for(let item of this.baby_list){
                    if(item.id == value){
                        if(item.live_time == '0'){
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name+'暂未入住',
                            })
                            this.form.live_time = ''
                            return
                        }
                        this.form.live_time = this.formatDateTime(item.live_time)
                    }
                }
            },
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '-' + m + '-' + d
            },
            //获取宝宝
            get_baby_list (){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.monthLiveApi.babyList(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.baby_list = res.data
                        console.info(this.form.baby_id)
                        for(let item of res.data){
                            if(item.id == this.form.baby_id){
                                this.form.live_time = this.formatDateTime(item.live_time)
                            }
                        }
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '-' + m + '-' + d
            },
            //请求用户基本信息
            apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.form.momName = res.data.name
                        this.form.room = res.data.room_name
                        this.child_birth = this.formatDateTime(res.data.child_birth)
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            save(){
                let signature ='signature1'
                let png = this.$refs[signature].save()
                this.form.agent_sign = encodeURI(png)
                this.showSignature = true
            },
            edit(){
                this.showSignature = false
                this.form.agent_sign = ''
            },
            clear(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.agent_sign = ''
            },
            //请求详情数据
            apiDetail(name){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.chritmasFormApi.getBabyHeathRecord(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        let data = res.data
                        this.form.room = data.room
                        this.form.baby_id=data.baby_id,
                        this.form.agent_id=data.agent_id,
                        this.form.birth_day=data.birth_day,
                        this.form.jaundice=data.jaundice,
                        this.form.head_face=data.head_face,
                        // this.form.heart_lung=data.heart_lung,
                        this.form.heart_rate=data.heart_rate,
                        this.form.breathing=data.breathing,
                        this.form.limbs=data.limbs,
                        this.form.abdomen=data.abdomen,
                        this.form.hip=data.hip,
                        this.form.genitals=data.genitals,
                        this.form.special_case=data.special_case,
                        // this.form.deal_desc=data.deal_desc,
                        this.form.deal=data.deal,
                        this.form.advisory_date=data.advisory_date,
                        this.form.shifts=data.shifts,
                        this.form.agent_sign=data.agent_sign.indexOf(this.get_host) != -1 ? data.agent_sign : this.get_host+data.agent_sign  
                        this.showSignature = true
                        if(name.length){
                            for(let item of name){
                                if(item.id == data.agent_id){
                                    this.cfrText = item.user_name
                                }
                            }
                        }
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求添加数据
            apiAddForm(){
                let babyName = ''
                for(let item of this.baby_list){
                    if(item.id == this.form.baby_id){
                        babyName = item.name
                    }
                }
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id,
                    room:this.form.room,
                    baby_id:this.form.baby_id,
                    agent_id:this.form.agent_id,
                    birth_day:this.form.birth_day,
                    jaundice:this.form.jaundice,
                    head_face:this.form.head_face,
                    // heart_lung:this.form.heart_lung,
                    heart_rate:this.form.heart_rate,
                    breathing:this.form.breathing,
                    limbs:this.form.limbs,
                    abdomen:this.form.abdomen,
                    hip:this.form.hip,
                    genitals:this.form.genitals,
                    special_case:this.form.special_case,
                    deal:this.form.deal,
                    advisory_date:this.form.advisory_date,
                    shifts:this.form.shifts,
                    agent_sign:this.form.agent_sign               
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.chritmasFormApi.addBabyHeathRecord(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'christmas_form_two',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            // 请求更新数据
            apiUpdateForm(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id,
                    maternal_info_id: this.$route.query.id,
                    room:this.form.room,
                    baby_id:this.form.baby_id,
                    agent_id:this.form.agent_id,
                    birth_day:this.form.birth_day,
                    jaundice:this.form.jaundice,
                    head_face:this.form.head_face,
                    heart_rate:this.form.heart_rate,
                    breathing:this.form.breathing,
                    // heart_lung:this.form.heart_lung,
                    
                    limbs:this.form.limbs,
                    abdomen:this.form.abdomen,
                    hip:this.form.hip,
                    genitals:this.form.genitals,
                    special_case:this.form.special_case,
                    // deal_desc:this.form.deal_desc,
                    deal:this.form.deal,
                    advisory_date:this.form.advisory_date,
                    shifts:this.form.shifts,
                    agent_sign:this.form.agent_sign.indexOf(this.get_host) != -1 ? this.form.agent_sign.replace(this.get_host,'') : this.form.agent_sign,                 
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.chritmasFormApi.updateBabyHeathRecord(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'christmas_form_two',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            submitForm(){
                let form = this.form
                if(form.baby_id == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择宝宝',
                    })
                    return
                }
                if(form.advisory_date == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择健康咨询日期',
                    })
                    return
                }
                if(form.birth_day == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入出生天数',
                    })
                    return
                }
                if(form.jaundice == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入黄疸',
                    })
                    return
                }
                if(form.head_face == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入头面部',
                    })
                    return
                }
                if(form.heart_lung == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入心肺',
                    })
                    return
                }
                if(form.limbs == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入四肢',
                    })
                    return
                }
                if(form.abdomen == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入腹部',
                    })
                    return
                }
                if(form.hip == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入臀部',
                    })
                    return
                }
                if(form.genitals == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入生殖器',
                    })
                    return
                }
                if(form.special_case == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入特殊情况',
                    })
                    return
                }
                if(form.deal == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择处理',
                    })
                    return
                }
                if(form.shifts == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择班次',
                    })
                    return
                }
                if(form.agent_id == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择查房人',
                    })
                    return
                }
                if(form.agent_sign == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入签名',
                    })
                    return
                }
                
                // 判断宝宝是否入住
                let time = 0
                if(this.baby_list.length){
                    for(let item of this.baby_list){
                        if(item.id == this.form.baby_id){
                            time = item.live_time
                        }
                    }
                }
                if(time == '0'){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '该宝宝暂未入住',
                    })
                    return
                }
                if(this.$route.query.list_id){
                    console.info("请求更新数据")
                    this.apiUpdateForm()
                }else{
                    console.info("请求添加数据")
                    this.apiAddForm()
                }
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/christmas_form_two.vue